<script lang="ts">
	import {getContext} from "svelte";
    import {Utils} from "../../util";
    import type {Context} from "svelte-simple-modal/types/Modal.svelte";
    import {uploadProgressStore} from "../../stores.js";
    import {Circle3} from "svelte-loading-spinners";
    const { close } = getContext<Context>('simple-modal');

	export let onClose: () => void;

    export let message: string;
    export let title:string;

	function closeMe() {
        console.log("close dialog");
		close();
		onClose?.();
}
</script>

<div class="modal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
    <div class="modal-header">
        <div class="modal-title">
            {title}
        </div>
        <button type="button" class="modal-close" on:click={closeMe}>
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.65685 2.43466e-05L6.60183 0.945001L0.944977 6.60186L0 5.65688L5.65685 2.43466e-05Z" fill="#F8F7F7"/>
                <path d="M5.65685 6.60183L6.60183 5.65685L0.944977 0L0 0.944977L5.65685 6.60183Z" fill="#F8F7F7"/>
            </svg>
        </button>
    </div>
    <div class="modal-body">

        <!--
                        <progress value={$uploadProgressStore.value} max="100">{$uploadProgressStore.value}%</progress>
        --->
            <div class="success-box">

                <div style="width:250px;">
                    <svg width="133px" height="133px" viewBox="0 0 133 133" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="check-group" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <circle id="filled-circle" fill="#F64E60" cx="66.5" cy="66.5" r="54.5"></circle>
                            <circle id="white-circle" fill="#FFFFFF" cx="66.5" cy="66.5" r="55.5"></circle>
                            <circle id="outline" stroke="#F64E60" stroke-width="4" cx="66.5" cy="66.5" r="54.5"></circle>
                            <path id="check" d="M40,40 L93,93 M93,40 L40,93" stroke="#FFFFFF" stroke-width="4"></path>

                        </g>
                    </svg>

                </div>

                <div class="success-info-text">
                    <h4>
                        {message}

                    </h4>
                </div>
            </div>

    </div>

</div>

<style lang="scss">
  .modal {
    background: #FFFFFF;
    border-radius: 16px;

    padding: 50px;

    /* 600px, 900px, 1200px, and 1800px */
    @media (max-width: 600px) {
      padding: 20px;
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      align-items: baseline;

      .modal-title {
        //font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        //color: #000000;
        color: $primary-color;
      }

      button.modal-close {

        margin-left:2rem;
        border-radius: 9px;
        border: 0;
        /* all: unset; */
        cursor: pointer;
        background: $secondary-color;
        display: flex;
        padding: 0.75rem;


          //line-height: 0;
          svg {
            transform: scale(2);
          }


      }
    }
    .modal-body {
      margin-bottom: 20px;
      color:$primary-color;
      /* 600px, 900px, 1200px, and 1800px */
      @media (max-width: 600px) {
        margin-bottom: 30px;
      }
    }

    .modal-footer {
      display: flex;
      justify-content: center;

      .modal-button {
        all: unset;
        cursor: pointer;
        color:white;
        background: $secondary-color;
        border-radius: 9px !important;
        //font-family: 'Open Sans', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 23px;
        padding: 10px 85px;
        display:flex;
        align-items: center;
        justify-content: center;
        width:100%;

        svg{
          width:30px;
          margin-right:1rem;
        }

        /* 600px, 900px, 1200px, and 1800px */
        @media (max-width: 600px) {
          padding: 10px 20px;
        }

        &:hover {
          background: darken($secondary-color, 10%);
        }
      }
    }
  }

  .progress-element{

    margin-top:1rem;

  }
  .progress-container {
    position: relative;
    display: flex;
    background: #E7E7E7;
    height: 20px;
    border-radius: 20px;
    overflow: hidden;

    .progress-bar{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 0%;
    background: $secondary-color;
    transition:  1s ease-in;
    }

  }


  .progress-label{
    display:flex;
    justify-content: space-between;
  }


  .success-box{
    display:flex;
    justify-content: start;
    align-items: center;

    .success-info-text{
      font-weight: bold;
      color:$primary-color;
      padding-left:2rem;
    }
  }

  /* animated check */

  $radius: 55px;
  $circumf: 3.1416 * $radius * 2;
  $check-len: 75px;

  @keyframes outline {
    from {
      stroke-dasharray: 0, $circumf;
    }
    to {
      stroke-dasharray: $circumf, $circumf;
    }
  }

  #outline {
    animation: .38s ease-in outline;
    transform: rotate(0deg);
    transform-origin: center;
  }

  @keyframes circle {
    from {
      transform: scale(1);
    }
    to {
      transform: scale(0);
    }
  }

  #white-circle {
    animation: .35s ease-in .35s forwards circle;
    transform: none;
    transform-origin: center;
  }

  @keyframes check {
    from {
      stroke-dasharray: 0, $check-len;
    }
    to {
      stroke-dasharray: $check-len, $check-len;
    }
  }

  #check {
    animation: .34s cubic-bezier(0.65, 0, 1, 1) .8s forwards check;
    stroke-dasharray: 0, $check-len;
  }

  @keyframes check-group {
    from {
      transform: scale(1);
    }

    50% {
      transform: scale(1.09);
    }

    to {
      transform: scale(1);
    }
  }

  #check-group {
    animation: .32s ease-in-out 1.03s check-group;
    transform-origin: center;
  }


  .cancel-btn{
    background:$error-color;
  }


</style>
